const INITIAL_STATE = {
  statusCode: '',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'API_REJECTED':
      return {
        statusCode: payload.code,
      };
    case 'INITIAL_STATE':
    case 'SIGNATURE_INITIAL_STATE':
      return {
        statusCode: payload.statusCode,
      };
    default:
  }
  return state;
};
